export default __webpack_public_path__ + "static/media/la_capelle16.89c2820f.jpg";